import { useEffect, useState } from 'react';
import { Path, FieldValues, Control, useController, FieldError, PathValue, Controller } from 'react-hook-form';
import { format } from 'rut.js';
import validaRut from '../../../../utils/validaRut';
import { FormHelperText, TextField } from '@mui/material';

interface InputRutProps<
  K extends FieldValues,
  T extends PathValue<K, Path<K>> | undefined
> {
  name: Path<K>;
  control: Control<K>;
  error?: FieldError;
  defaultValue?: T;
  disabled?: boolean;
  readonly?: boolean;
  className?: string;
  label?: string;
}




export default function InputRut<
  K extends FieldValues,
  T extends PathValue<K, Path<K>> | undefined
>(props: InputRutProps<K, T>) {
  const { field: inputField } = useController({
    name: props.name,
    control: props.control,
  });
  const [rutFormat, setRutFormat] = useState<string>('');
  const [errorRut, setErrorRut] = useState<string | undefined>(undefined);

  const formatRut = (rut: string) => {
    if (!rut) {
      return '';
    }
    // Formatear el RUT limpio
    let rutFormateado = format(rut);
    return rutFormateado;
  };

  useEffect(() => {
    if (props.defaultValue) {
      inputField.onChange(props.defaultValue);
    }
  }, [props.defaultValue, inputField]);

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        render={({ field: inputField, fieldState }) => (

          <>
            <TextField
              {...inputField}
              type="text"
              value={formatRut(inputField.value as string) || ''}
              onChange={(e) => {
                const cleanValue = e.target.value.replace(/[^0-9kK]/g, '');
                const newFormattedValue = formatRut(cleanValue);
                inputField.onChange(cleanValue); // Mantener valor limpio para validación
                inputField.onChange(newFormattedValue); // Aplicar formato para visualización
              }}
              // disabled={props.disabled}
              autoComplete="off"
              slotProps={{
                htmlInput: {
                  readOnly: props.readonly,
                  maxLength: 12,
                  disabled: props.disabled
                },
              }}
              // autoFocus
              margin="dense"
              label={props.label}
              fullWidth
              variant="standard"
              error={!!props.error}
              disabled={props.disabled}
            />
            {props.error && <FormHelperText error>{props.error.message}</FormHelperText>}
          </>
        )
        }
      />
    </>
  );
}
